import React from 'react';
import './WhyChooseUs.css';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: '⚙️',
    title: 'Custom Software Development',
    description: 'Tailored solutions built from ground up for your unique business needs.',
    // link: '/website-development',
  },
  {
    icon: '🔬',
    title: 'Test Automation Specialist',
    description: 'End-to-end automation frameworks ensuring flawless software delivery.',
    // link: '/quality-engineering',
  },
  {
    icon: '💬',
    title: 'Transparent Communication',
    description: 'Clear, honest, and consistent communication throughout every project.',
  },
  {
    icon: '🛠️',
    title: 'Post Development Support',
    description: 'Ongoing maintenance and support to keep your systems running smoothly.',
  },
];

const WhyChooseUs = () => {
  return (
    <section className="snow-why" id="why-choose-us">
      {/* Aurora background */}
      <div className="snow-why-aurora">
        <div className="snow-aurora-band snow-aurora-band-1"></div>
        <div className="snow-aurora-band snow-aurora-band-2"></div>
        <div className="snow-aurora-band snow-aurora-band-3"></div>
      </div>

      <div className="snow-why-inner">
        <div className="snow-why-header">
          <span className="snow-section-label">❆ Your Technology Partner</span>
          <h2 className="snow-why-title">
            Why Choose <span className="snow-why-highlight">SnowTechLabs?</span>
          </h2>
          <p className="snow-why-subtitle">
            When you partner with SnowTechLabs for your technology needs, you can
            be sure of getting
          </p>
        </div>

        <div className="snow-why-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="snow-why-card"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="snow-why-card-glow"></div>
              <div className="snow-why-card-icon">
                <span>{feature.icon}</span>
              </div>
              <h3 className="snow-why-card-title">
                {feature.link ? (
                  <Link to={feature.link}>{feature.title}</Link>
                ) : (
                  feature.title
                )}
              </h3>
              <p className="snow-why-card-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
